<template>
    <div class="py-16">
        <v-row align="center" class="row--small">
            <v-col cols="12">
                <v-row align="center" class="row--small">
                    <v-col cols="auto">
                        <v-avatar color="grey" class="v-avatar--small">
                            <v-img :src="profileSrc">
                                <v-fade-transition>
                                    <v-icon v-show="!profileSrc" color="white">mdi-account</v-icon>
                                </v-fade-transition>
                            </v-img>
                        </v-avatar>
                    </v-col>
                    <v-col>
                        <v-layout class="flex-row flex-lg-column flex-xl-row align-center align-lg-start align-xl-center" style="gap: 4px">
                            <h5 class="page-text--lg font-weight-medium grey-13--text">
                                {{ value?.resume?.personalInformation?.name }}
                            </h5>
                            <p class="page-text--sm grey-9--text">({{ gender }}, {{ age }})</p>
                            <application-view v-bind="{ value, recruitment }" ref="application-view">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="{ ...attrs }" v-on="on" icon text small color="grey-9" class="my-n2">
                                        <v-icon> mdi-checkbox-multiple-blank-outline </v-icon>
                                    </v-btn>
                                </template>
                            </application-view>
                        </v-layout>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
                <template v-for="(text, i) in cardTextList">
                    <span :key="`card-text-item-${i}`" class="page-text--sm grey-6--text">{{ text }}</span>
                    <span :key="`card-text-item-${i}-divider`" class="page-text--sm grey-6--text px-10" v-if="i < cardTextList.length - 1"> / </span>
                </template>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { initApplication, initRecruitment } from "@/assets/variables";
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, GENDERS } from "@/assets/variables";

import ApplicationView from "./application-view.vue";

export default {
    components: {
        ApplicationView,
    },
    props: {
        value: { type: Object, default: initApplication }, // application
        recruitment: { type: Object, default: initRecruitment },
    },
    computed: {
        gender() {
            return GENDERS[this.value?.resume?.personalInformation?.gender]?.text;
        },
        age() {
            let { bornAt } = this.value?.resume?.personalInformation || {};
            if (bornAt) bornAt = `${dayjs().diff(bornAt, "year")}세`;
            return bornAt;
        },
        profileSrc() {
            return this.value?.resume?.profile?.url;
        },
        area() {
            let { address1 } = this.value?.resume?.personalInformation?.residence || {};
            return address1?.split?.(" ")?.slice?.(0, 2)?.join?.(" ");
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.resume?.personalInformation?.phone?.phoneNumberFormat?.(), this.area, this.education].filter((item) => !!item);
        },
    },
    methods: {
        openApplication() {
            this.$refs["application-view"].shows = true;
        },
    },
};
</script>

<style></style>
